import ApiResponse from "sr/models/ApiResponse";
import { post } from "../axios";

export const login = async (postData: any): Promise<ApiResponse<any>> => {
  try {
    const res = await post<ApiResponse<any>>("/auth", postData);

    if (res.success) {
      document.cookie = `refreshToken=${res?.data?.auth?.jwt_refresh}; path=/; SameSite=Strict`;
    }

    return res;
  } catch (e: any) {
    // Return the backend error response (e.g. 400 with USER.IS.DELETED)
    if (e?.response?.data) {
      return e.response.data;
    }

    // Unexpected error (network/server)
    return {
      success: false,
      msg: "UNKNOWN_ERROR",
      error: {
        message: e?.message || "Something went wrong.",
      },
    } as ApiResponse<any>;
  }
};
